import React from 'react';
import PropTypes from 'prop-types';

import styled, { withTheme } from 'styled-components';

const Button = styled.button`
  padding: 0;
  margin: 0;
  background: ${props => props.theme.formBackground};
  /* border: thin solid ${props => props.theme.borderColor}; */
  /* border-top: 0; */
  border: 0;
  cursor: pointer;
  outline: 0;

  & > * {
    pointer-events: none;
  }
`;

const Svg = props => (
  <svg width="25" height="50">
    <g className="layer">
      <title>Layer 1</title>
      <ellipse
        cx="12.5"
        cy="19"
        fill="none"
        id="svg_6"
        rx="5"
        ry="0.032"
        stroke={props.color}
        strokeDasharray="null"
        strokeLinecap="null"
        strokeLinejoin="null"
        strokeWidth="2"
      />
      <ellipse
        cx="12.5"
        cy="25"
        fill="none"
        id="svg_9"
        rx="5"
        ry="0.032"
        stroke={props.color}
        strokeDasharray="null"
        strokeLinecap="null"
        strokeLinejoin="null"
        strokeWidth="2"
      />
      <ellipse
        cx="12.5"
        cy="31"
        fill="none"
        id="svg_10"
        rx="5"
        ry="0.032"
        stroke={props.color}
        strokeDasharray="null"
        strokeLinecap="null"
        strokeLinejoin="null"
        strokeWidth="2"
      />
    </g>
  </svg>
);

const TableButton = ({ width, height, theme, id }) => (
  <Button id={id} type="button">
    <Svg width={width} height={height} color={theme && theme.borderColor} />
  </Button>
);

TableButton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.object,
  id: PropTypes.string,
};

TableButton.defaultProps = {
  theme: {},
  id: 'tableButton',
  height: '50px',
  width: '25px',
};

Svg.propTypes = {
  color: PropTypes.string,
};

Svg.defaultProps = {
  color: '',
};

export default withTheme(TableButton);
